import React, { useEffect, useState } from "react";
import "./styles/EmailModal.css"; // wir nutzen gleich diese CSS-Datei
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { em } from "framer-motion/client";

export default function EmailModal({ isOpen, onClose, option }) {
  const options = [
    { value: "Kontakt", label: "Kontakt" },
    { value: "Rund ums Haus", label: "Rund ums Haus" },
    { value: "Rund im Haus", label: "Rund im Haus" },
    { value: "Services", label: "Services" },
    { value: "Rund um den Garten", label: "Rund um den Garten" },
    { value: "Hüpfburg verleih", label: "Hüpfburg verleih" }
  ];

  console.log(option)

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [selectedOption, setSelectedOption] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (option === -1)
      setSelectedOption(null)
    else
      setSelectedOption(options[option])
  }, [option])

  const sendMail = (name, email, message, subject) => {
    fetch('https://rundumkrebs.de/api/send', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: name,
        email: email,
        message: message,
        subject: subject
      })
    })

  }

  const buildMessage = () => {
    return (
      `${selectedOption.label} gewünscht am ${selectedDate ? selectedDate.toLocaleDateString('de-DE') : '[kein Datum gewählt]'}\n\n` +
      `${message}\n\n` +
      `tel.: ${phone}`
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError("Bitte gib eine gültige E-Mail-Adresse ein.");
      return;
    }
    await sendMail(name, email, buildMessage(), selectedOption.label)


    onClose(); // Modal schließen
  };

  if (!isOpen) return null;


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Anfrage</h2>
        <form onSubmit={handleSubmit}>
          <label>
            E-Mail*
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Name*
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label>
            Leistung*
            <Select
              options={options}
              value={selectedOption}
              onChange={(selected) => setSelectedOption(selected)}
              placeholder="Wählen sie ihren Service..."
            />
          </label>
          <label>
            Wann?
            <div>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd.MM.yyyy"
                placeholderText="Datum wählen"
                className="datepicker-input"
              />
            </div>
          </label>
          <label>
            Telefonnummer:
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </label>

          <label>
            Nachricht
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
            />
          </label>
          {error && <p className="error">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={onClose}>
              Abbrechen
            </button>
            <button type="submit">Senden</button>
          </div>
        </form>
      </div>
    </div>
  );
}
